import { z } from "zod"
import { Address, isAddress } from "viem"
import { ProjectConfigBribeSchema, type ProjectConfigBribeType } from "@tutellus/dappcomposer-contracts-ifaces"

export const ProjectConfigBribeValidation = z.object({
  poolID: z.string({ required_error: "id is required" }),
  address: z.string({ required_error: "address is required" }).refine(isAddress),
})

export class ProjectConfigBribe {
  constructor(
    private readonly _poolID: string,
    private readonly _address: Address,
  ) {}

  static create({ poolID, address }: z.infer<typeof ProjectConfigBribeValidation>) {
    const { success, error } = ProjectConfigBribeValidation.safeParse({ poolID, address })
    if (!success) throw new Error(error.message)
    return new ProjectConfigBribe(poolID, address)
  }

  static createFromAPI({ poolID, address }: ProjectConfigBribeType) {
    const { success, error } = ProjectConfigBribeSchema.safeParse({ poolID, address })
    if (!success) throw new Error(error.message)
    return ProjectConfigBribe.create({ poolID, address: address as Address })
  }

  get poolID() { return this._poolID } // prettier-ignore
  get address() { return this._address } // prettier-ignore

  serialize() {
    return {
      poolID: this._poolID,
      address: this._address,
    }
  }
}

export type ProjectConfigBribeSerialized = ReturnType<ProjectConfigBribe["serialize"]>
